import '@/assets/scss/main.scss';
import '@/common/filters';
import '@/components/ui/index.js';
import Device from '@/plugins/device';
import i18n, { setLanguage } from '@/plugins/i18n';
import Session from '@/plugins/session';
import Validation from '@/plugins/validation';
import VueMask from 'v-mask';
import Vue from 'vue';
import FlagIcon from 'vue-flag-icon';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
export const eventHub = new Vue();

Vue.use(VueMask);
Vue.use(Session);
Vue.use(Validation);
Vue.use(Device);
Vue.use(FlagIcon);

Vue.config.productionTip = false;

eventHub.$on('LOGGED_USER', (user) => {
	setLanguage(user.language);
});

new Vue({
	i18n,
	router,
	vuetify,
	render: (h) => h(App),
}).$mount('#app');
